import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./store/context/auth";
import { Provider } from "react-redux";
import { store } from "./store/redux/store";
// import { faviconIcon } from "./config";
import { getConfigData, getMaintenanceStatus } from "./util/API/tableServices";
import { setBaseConfig } from "./store/redux/config";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from '@datadog/browser-rum-react';
import MixpanelTracker from "./components/MixpanelTracker/MixpanelTracker";
import UnderMaintenance from "./pages/UnderMaintenance/UnderMaintenance";
 
const root = ReactDOM.createRoot(document.getElementById("root"));
 
// document.title = title;
 
const normalizeConfig = (payload) => {
  const config = {};
  payload.forEach((item) => {
    // console.log(item)
    const { configid, configvalue } = item.b;
    config[configid] = configvalue;
  });
  return config;
};
 
const booleanizeConfig = (config) => {
  const result = {};
 
  Object.entries(config).forEach(([key, value]) => {
    if (typeof value === "string") {
      const lower = value.toLowerCase();
      if (lower === "true") result[key] = true;
      else if (lower === "false") result[key] = false;
      else result[key] = value;
    } else {
      result[key] = value;
    }
  });
 
  return result;
};


// const getConfigVariables = async () => {
//   const baseUrl = `${window.location.protocol}//${window.location.host}`;
//   // console.log(btoa("https://uat-paiyhub.ncsfsg.com/"))
//   // console.log(btoa("https://paiyhub.ncsfsg.com/"))
//   const encodedUrl = btoa(baseUrl);
//   const sessionCacheKey = `configData_${encodedUrl}`;

//   try {
//     const cachedData = sessionStorage.getItem(sessionCacheKey);

//     if (cachedData) {
//       // console.log("Using sessionStorage config — skipping API call.");
//       const parsedConfig = JSON.parse(cachedData);
//       const finalConfig = booleanizeConfig(parsedConfig);
//       applyConfig(finalConfig);
//       return;
//     }

//     // Fetch fresh config if none is cached
//     const response = await getConfigData(encodedUrl);
//     const payload = response?.data?.body?.payload || [];
//     const config = normalizeConfig(payload);


//     sessionStorage.setItem(sessionCacheKey, JSON.stringify(config));

//     const finalConfig = booleanizeConfig(config);
//     applyConfig(finalConfig);

//   } catch (error) {
//     console.error("Failed to fetch config:", error);
//     document.title = "PAiY";
//   }
// };

const getConfigVariables = async () => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const encodedUrl = btoa(baseUrl);
  const sessionCacheKey = `configData_${encodedUrl}`;

  try {
    const [configResponse, maintenanceResponse] = await Promise.all([
      getConfigData(encodedUrl),
      getMaintenanceStatus(encodedUrl)
    ]);

    const payload = configResponse?.data?.body?.payload || [];
    const config = normalizeConfig(payload);

    sessionStorage.setItem(sessionCacheKey, JSON.stringify(config));

    const finalConfig = booleanizeConfig(config);

    applyConfig(finalConfig);

    return {
      isUnderMaintenance: maintenanceResponse?.payload ?? false,
    };
  } catch (error) {
    console.error(error);
    document.title = "PAiY";

    return {
      isUnderMaintenance: false,
    };
  }
};

const applyConfig = (finalConfig) => {
  if (finalConfig?.title) document.title = finalConfig.title;
  if (finalConfig?.favicon) setFavicon(finalConfig.favicon);

  if (finalConfig?.isDatadogEnabled) {
    datadogRum.init({
      applicationId: finalConfig.datadogApplicationID,
      clientToken: finalConfig.datadogClientID,
      site: "datadoghq.com",
      service: finalConfig.datadogService,
      env: finalConfig.datadogEnvironment,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
      plugins: [reactPlugin({ router: true })],
    });

    datadogRum.startSessionReplayRecording();
    datadogRum.startView("/");
  }

  store.dispatch(setBaseConfig(finalConfig));
};
 
const setFavicon = (faviconPath) => {
  let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = faviconPath;
  document.head.appendChild(link);
};
 
// getConfigVariables().then(() => {
//   root.render(
//     <BrowserRouter>
//       <Provider store={store}>
//         <MixpanelTracker />
//         <AuthProvider>
//           <App />
//         </AuthProvider>
//       </Provider>
//     </BrowserRouter>
//   );
// });

getConfigVariables().then(({ isUnderMaintenance }) => {
  root.render(
    <BrowserRouter>
      {isUnderMaintenance ? (
        <UnderMaintenance />
      ) : (
        <Provider store={store}>
          <MixpanelTracker />
          <AuthProvider>
            <App />
          </AuthProvider>
        </Provider>
      )}
    </BrowserRouter>
  );
});